/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ListUnordered({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2.5 2.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8M2.5 7.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8M1.6 13a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0M6 2.4a.6.6 0 0 0 0 1.2h8.5a.6.6 0 1 0 0-1.2zM6 7.4a.6.6 0 0 0 0 1.2h8.5a.6.6 0 1 0 0-1.2zM6 13.6h8.5a.6.6 0 0 0 0-1.2H6a.6.6 0 1 0 0 1.2" /></svg>;
}
;